/**
 * TanStack Router: /people
 *
 * This route file was auto-generated by the route generation script.
 * Component: PeoplePage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PeoplePage from '@/app/people/page'

/**
 * Route: /people
 * Layout: _auth (authenticated)
 * Component: PeoplePage
 */
export const Route = createFileRoute('/_auth/people')({
  component: PeoplePage,
})
